import useResource from "./useResource"

export default function useFeatureFlag(feature) {
  const [data] = useResource({ key: "/features" })

  return data[feature]
}
